import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class ReportService {
  static reportdashboardDetails = async (from, to) => {
    const reporturl =
      "/orders/sales/report-dashboard?from=" + from + "&to=" + to;

    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + reporturl,
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let dashboardDetail = response.data.data;
      return dashboardDetail;
    } catch (err) {
      throw err;
    }
  };

  static reportdateDetails = async (date) => {
    const reporturl = "/orders/sales/report-by-date?date=" + date;

    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + reporturl,
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let dateDetail = response.data.data;

      return dateDetail;
    } catch (err) {
      throw err;
    }
  };

  static reportdaterangeDetails = async (from, to) => {
    const reporturl =
      "/orders/sales/report-date-range?from=" + from + "&to=" + to;

    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + reporturl,
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let daterangeDetail = response.data.data;

      return daterangeDetail;
    } catch (err) {
      throw err;
    }
  };

  //publisher, medium, subject and category single API
  static staticDetails = async () => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/reports/statics/view",
      });

      let staticDetails = response.data.data;

      return staticDetails;
    } catch (err) {
      throw err;
    }
  }

  static reportProductDetailsSearch = async (productId, rowsPerPage, page) => {
      try {
        let filter = [];
  
            if (productId) {
              filter.push({'productId': productId})
            }
  
        let response = await axios({
          method: "post",
          baseURL: API_ORIGIN + "/reports/admin/search",
          data: {
            filter: filter,
            limit: rowsPerPage,
            skip: page * rowsPerPage,
            sort: "DESC",
          },
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        let productDetail = response.data.data;
        return productDetail;
      } catch (err) {
        throw err;
      }
    };

    static orderReportDetails = async (arrayData, rowsPerPage, page) => {
    try {
      let filterArray = [];
     
      if (arrayData && arrayData.length > 0) {
        arrayData.map((data) => {
          if(data.searchTerm !== "" && data.searchTerm !== undefined){
            filterArray.push({"id": data.searchTerm})
          }

          if(data.dateFrom !== "" && data.dateFrom !== undefined){
            filterArray.push({"order_date_from": data.dateFrom})
          }

          if(data.dateTo !== "" && data.dateTo !== undefined){
            filterArray.push({"order_date_to": data.dateTo})
          }
    
          if(data.statusname !== "" && data.statusname !== undefined){
            filterArray.push({"status": data.statusname})
          }
    
          if(data.paymentMethod !== "" && data.paymentMethod !== undefined){
            filterArray.push({"payment_method": data.paymentMethod})
          }
    
          if(data.paymentStatus !== "" && data.paymentStatus !== undefined){
            filterArray.push({"payment_status": data.paymentStatus})
          }

          if(data.type !== "" && data.type !== undefined){
            filterArray.push({"currier_type": data.type})
          }
            
        })
      }
console.log('filterArray',filterArray)
console.log('rowsPerPage',rowsPerPage)
console.log('page',page)

      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/reports/order-report/dashboard",
        data: {
          filter: filterArray,
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let orderDetail = response.data.data;
console.log('orderDetail',orderDetail)
      return orderDetail;
    } catch (err) {
      throw err;
    }
  };
}
